import React from "react";
import styles from "./ProtectedLayout.module.scss";
import moment from "moment"


import { FaCalendarAlt } from "react-icons/fa";
import { AiOutlineSearch } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";

import { setValue } from "../../features/SearchReducer";


export default function Navbar({ isSearchBar,title }) {

    const { search } = useSelector(state => state.search);
    const dispatch = useDispatch();



    return (
        <div className={styles.Navbar}>
            <div className={styles.titleContainer}>
                <h3 className={styles.title}>{title}</h3>
            </div>
            {isSearchBar ?
                <div className={styles.search}>
                    <input type="text" placeholder="Search" value={search} onChange={(e) => dispatch(setValue(e.target.value))} />
                    <div className={styles.searchButton}>
                        <AiOutlineSearch />

                    </div>

                </div>
                : ""}

        </div >
    )
}